import { useMutation as w } from "@apollo/client";
import { accountSchema as W } from "../../deserialize/yup/account.js";
import { deserializeData as h } from "../../graphql/deserialize/index.js";
import v from "../../graphql/mutation/bindWalletAddress.js";
import C from "../account/useGetBindWalletInput.js";
import b from "../generic/useChainSwitcher.js";
import y from "../web3/useWeb3.js";
import * as r from "ramda";
import { useCallback as A } from "react";
const M = () => {
  const [t, { loading: n }] = w(v), { detectWalletType: e } = b(), { getBindWalletInput: o } = C(), { getWalletAccount: a } = y();
  return {
    mutate: A(
      async (s) => {
        const i = e(), { message: c, signature: m, messageTimestamp: l, network: d, provider: p } = await o(i), u = r.isNil(s) ? {} : { invitationCode: r.pathOr("", ["invitation", "code"], s) }, f = await a(), g = await t({
          variables: {
            input: {
              network: d,
              address: f.address,
              message: c,
              signature: m,
              messageTimestamp: l,
              isSmartContract: !1,
              walletProviderType: p,
              ...u
            }
          }
        });
        return h(g, W);
      },
      [e, o, a, t]
    ),
    loading: n
  };
};
export {
  M as default
};
//# sourceMappingURL=useBindWalletAddress.js.map
